import { render, staticRenderFns } from "./AbaClassificadosConcurso.vue?vue&type=template&id=2e2b2212"
import script from "./AbaClassificadosConcurso.vue?vue&type=script&lang=ts"
export * from "./AbaClassificadosConcurso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports